// 导入 axios
import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { CheckIsTimeOut } from '@/utils/auth'
// 创建一个 axios 副本
const instance = axios.create({
  // 设置基地址
  baseURL: process.env.VUE_APP_BASE_API,
  // 设置超时时间
  timeout: 10000,
})
//请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 获取 token
    // const token = store.getters.token;
    const token = localStorage.getItem('token')

    if (token) {
      if (CheckIsTimeOut()) {
        store.dispatch('user/logout')
        // router.push('/');
        return Promise.reject(new Error('token 超时了,请重新登录'))
      }
      // 统一设置请求头中的 token
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功时的回调函数
  (response) => {
    // 得到返回的数据
    const { message, success } = response.data
    // console.log(response.data);
    // 判断状态
    if (success) {
      // 网络请求正常的
      return Promise.resolve(response.data)
      // 经过这个 return 将来网络请求得以的数据不需要再从 res.data 中的取数据了，可以直接得到结果
    } else {
      // 提示出错
      Message({
        message: message,
        type: 'error',
      })
      // 网络请求出错
      return Promise.reject(new Error(message))
    }
  },
  // 请求失败时的回调函数
  (error) => {
    if (error.response && error.response.data && error.response.data.errorCode) {
      store.dispatch('user/logout')
      const path = window.location.href.split('#')[1]
      router.push(`/login?_redirect=${path}`)
    } else {
      Message.error(error.message);
    }
    // Message.error("账号或密码错误!");
    return Promise.reject(error)
  }
)
// 暴露给外界
export default instance
